import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DB from '../../data/mockData';

export default function NewProjectModal({ show, onClose }) {
  const navigate = useNavigate();
  const [product, setProduct] = useState('');

  if (!show) return null;

  const handleCreate = () => {
    onClose();
    navigate('/pipeline');
  };

  return (
    <div className="modal-backdrop-fo" onClick={onClose}>
      <div className="modal-fo" onClick={e => e.stopPropagation()}>
        <button className="mcl" onClick={onClose}>✕</button>
        <div className="m-title">Add Project to Pipeline</div>
        <div className="m-sub">Nova notifies all departments and creates task lists automatically</div>

        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">Product</label>
            <input className="finput" placeholder="Product name" value={product} onChange={e => setProduct(e.target.value)} />
          </div>
          <div className="col-sm-6">
            <label className="flabel">Supplier</label>
            <select className="finput">
              {DB.suppliers.map(s => <option key={s.id}>{s.name}</option>)}
            </select>
          </div>
        </div>
        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">Starting Stage</label>
            <select className="finput"><option>Assess</option><option>Negotiate</option></select>
          </div>
          <div className="col-sm-6">
            <label className="flabel">Est. Revenue</label>
            <input className="finput" placeholder="e.g. €1.2M/yr" />
          </div>
        </div>
        <div className="mb-3">
          <label className="flabel">Project Notes</label>
          <textarea className="finput" rows="3" placeholder="Context, rationale, initial observations…" style={{ resize: 'vertical' }} />
        </div>

        <div className="p-3 rounded-2 mb-3" style={{ background: 'var(--teal3)', fontSize: 12, color: 'var(--teal)' }}>
          ✦ Nova will notify Commercial, Legal and RA · create task lists · set deadline reminders · monitor progress
        </div>

        <div className="d-flex justify-content-end gap-2 pt-3 border-top">
          <button className="btn btn-s" onClick={onClose}>Cancel</button>
          <button className="btn btn-p" onClick={handleCreate}>Create Project</button>
        </div>
      </div>
    </div>
  );
}
